import { useState } from 'react'
import { getFullAttachmentUrl } from '@services/api/index.js'

const PartnerCard = ({ partner, onClick }) => {
  const [imageLoaded, setImageLoaded] = useState(false)
  const [imageError, setImageError] = useState(false)

  return (
    <div
      className="bg-white rounded-lg border border-gray-200 shadow-sm hover:shadow-md hover:border-primary-300
                 transition-all duration-200 p-4 cursor-pointer flex flex-col items-center text-center group"
      onClick={() => onClick && onClick(partner)}
    >
      {/* Logo / 头像 */}
      <div className="w-20 h-20 bg-gray-50 rounded-xl p-2 flex items-center justify-center mb-3 ring-1 ring-inset ring-gray-200 group-hover:ring-primary-300 transition-colors">
        {partner.logoId && !imageError ? (
          <img
            src={getFullAttachmentUrl(partner.logoId)}
            alt={partner.orgName}
            className={`w-full h-full object-contain transition-opacity duration-300 ${
              imageLoaded ? 'opacity-100' : 'opacity-0'
            }`}
            onLoad={() => setImageLoaded(true)}
            onError={() => setImageError(true)}
            loading="lazy"
          />
        ) : (
          <div className="w-full h-full bg-gray-100 rounded-lg flex items-center justify-center">
            <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
            </svg>
          </div>
        )}
      </div>

      {/* 机构名称 */}
      <h3 className="text-sm font-medium text-gray-900 group-hover:text-primary-600 transition-colors line-clamp-2">
        {partner.orgName}
      </h3>
    </div>
  )
}

export default PartnerCard
